require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./i-am-so-clever-3.json") })
        }
      }, "path---i-am-so-clever-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---i-am-so-clever-3!./.cache/json/i-am-so-clever-3.json
// module id = 828
// module chunks = 231608221292675